<template>
  <div>
    <div class="container">
      <Breadcrumbs />
      <div class="row">
        <div class ='col-md-12 dBtnTop'>
          <q-btn
          data-cy="saveCity"
          unelevated
          @click='saveCity'
          class='bPrincipal'
          :icon="'img:' + require('@/assets/img/save.svg')"
          label="GUARDAR CAMBIOS"
          :disable="!form_dirty"/>
        </div>
      </div>
      <div class='row'>
    </div>
      <div class="row col-12">
        <div class="col-12">
          <EdicionCiudades
          :ciudad="ciudad"
          :indicesCiudad=" ciudad !== null? ciudad.indices : []"
          :indicesTematicos="indicesTematicos"
          :indices="indices"
          :indicesTematicosCiudad="this.indicesTematicosCiudadData"
          />
        </div>
      </div>
      <div class="row">
        <div class ='col-md-12 dBtnBottom'>
          <q-btn
          data-cy="saveCity"
          unelevated
          @click='saveCity'
          class='bPrincipal'
          :icon="'img:' + require('@/assets/img/save.svg')"
          label="GUARDAR CAMBIOS"
          :disable="!form_dirty"/>
        </div>
      </div>
      <DialogWarning
        v-model="showDialog"
        :showIcon="true"
        :txtContainer="
          `Los datos introducidos no han sido guardados. Si abandona el proceso sin guardar se perderán todos los cambios.¿Desea salir del municipio?`
        "
        labelDelete="SÍ, SALIR Y PERDER TODOS LOS CAMBIOS"
        labelCancel="NO, PERMANECER EN EL MUNICIPIO"
        @save="saveChanges()"
      />
    </div>
  </div>
</template>
<script>
import EdicionCiudades from '../components/EdicionCiudades.vue';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import DialogWarning from '@/shared/dialogs/warning/DialogWarning.vue';

export default {
  components: {
    EdicionCiudades,
    Breadcrumbs,
    DialogWarning
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudad: types.CIUDAD,
      indices: types.ALL_INDICES,
      indicesTematicos: types.ALL_INDICES_TEMATICOS
    })
  },
  created () {
    this.$store.dispatch(types.ACTION_GET_ALL_INDICES);
    this.$store.dispatch(types.ACTION_GET_ALL_INDICES_TEMATICOS);
    if (this.$route.params.idCiudad !== null && this.$route.params.idCiudad !== undefined) {
      this.$store.dispatch(types.ACTION_GET_CIUDAD, { idCiudad: this.$route.params.idCiudad }).then(response => {
        this.indicesTematicosCiudadData = this.ciudad.indicesTematicos;
        this.cityIndexEdited = this.ciudad && this.ciudad.indices ? this.ciudad.indices.map(indice => String(indice)) : [];
        this.hideLoading();
      }).catch(() => { this.hideLoading(); });
    }
  },
  mounted () {
    this.$eventHub.$on('viewEdited', (indexPayload = null) => {
      this.form_dirty = true;
      if (indexPayload && indexPayload.id !== undefined) this.changeArrayCityIndexEdited(indexPayload);
    });
    this.$eventHub.$on('viewEditedIndexTematicos', (ArrayCityIndexTemEdited) => {
      this.form_dirty = true;
      this.checkIndicesTematicos = true;
      this.changeArrayCityIndexTematicEdited(ArrayCityIndexTemEdited);
    });
    this.$eventHub.$on('viewEditedIndicadores', (ArrayCityIndicadoresEdited) => {
      this.form_dirty = true;
      this.checkIndicador = true;
      this.changeArrayCityIndicadoresEdited(ArrayCityIndicadoresEdited);
    });
    this.$eventHub.$on('viewSaved', () => {
      this.form_dirty = false;
      this.checkIndicesTematicos = false;
      this.checkIndicador = false;
      this.cityIndexEdited = [];
    });
  },
  beforeDestroy () {
    this.$store.commit(types.MUTATE_CIUDAD, null);
    this.$eventHub.$off('viewEdited');
    this.$eventHub.$off('viewEditedIndexTematicos');
    this.$eventHub.$off('viewEditedIndicadores');
    this.$eventHub.$off('viewSaved');
    this.$eventHub.$off('dirtyForm');
    this.$eventHub.$off('cleanForm');
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  data () {
    return {
      indicesTematicosCiudadData: [],
      // indicadoresCiudadData: [],
      cityIndexEdited: [],
      cityIndexTemEdited: [],
      cityIndicadoresEdited: [],
      checkIndicesTematicos: false,
      checkIndicador: false,
      form_dirty: false,
      showDialog: false,
      to: null
    };
  },
  watch: {
    ciudad (newCiudad) {
      if (!this.form_dirty) {
        this.cityIndexEdited = newCiudad && newCiudad.indices ? newCiudad.indices.map(indice => String(indice)) : [];
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.form_dirty) {
      next();
    } else {
      this.to = to;
      this.showDialog = true;
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (!this.form_dirty) {
      next();
    } else {
      this.to = to;
      this.showDialog = true;
    }
  },
  methods: {
    saveCity () {
      let indicesTematicosObject = {
        indicesEdited: this.cityIndexTemEdited,
        eventPassed: this.checkIndicesTematicos
      };

      let indicadoresObject = {
        indicadoresEdited: this.cityIndicadoresEdited,
        eventPassed: this.checkIndicador
      };

      this.$eventHub.$emit('saveCity', this.cityIndexEdited, indicesTematicosObject, indicadoresObject);
    },
    changeArrayCityIndexEdited ({ id, enabled }) {
      const idCityIndexEdited = String(id);
      const value = this.cityIndexEdited.indexOf(idCityIndexEdited);

      if (enabled && value === -1) {
        this.cityIndexEdited.push(idCityIndexEdited);
      }

      if (!enabled && value !== -1) {
        this.cityIndexEdited.splice(value, 1);
      }
    },
    changeArrayCityIndexTematicEdited (ArrayCityIndexTemEdited) {
      this.cityIndexTemEdited = [...ArrayCityIndexTemEdited];
    },
    changeArrayCityIndicadoresEdited (ArrayCityIndicadoresEdited) {
      this.cityIndicadoresEdited = [...ArrayCityIndicadoresEdited];
    },
    closeDialog () {
      this.showDialog = false;
      this.form_dirty = true;
      this.to = null;
    },
    saveChanges () {
      this.showDialog = false;
      this.form_dirty = false;
      this.$router.push(this.to.path);
    },
    beforeWindowUnload (e) {
      if (this.form_dirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bPrincipal {
  float: right;
}
.dBtnTop {
  margin-bottom: 15px;
}
.dBtnBottom {
  margin-top: 15px;
}
</style>
